import ThirdPartyConfig from "../ThirdPartyConfig/ThirdPartyConfig";
import Page from "../Page";
import { BackButton } from "src/common/components/BackButton";

const ThirdParty = () => {

    return (
      <Page title="Company | Smart-CMS">
        <BackButton
          text="Third Party"
          path="/dashboard"
        />
        <ThirdPartyConfig />
      </Page>
    );
}

export default ThirdParty;